import { blueprintKitchenData7 } from './blueprint-kitchen-data-7';

export const blueprintData7 = {
	id: '',
	email: '',
	submissionDate: '',
	submissionId: null,
	schemaVersion: 7,
	thumbnail: '',
	metadata: {
		estimateNumber: '',
		invoiceNumber: '',
		workorderNumber: '',
		paymentStatus: 'Not Paid'
	},
	notes: [],
	kitchens: [] as (typeof blueprintKitchenData7)[]
}
